var map = {
	"./CASTiT.png": "747d",
	"./CoreGuide.png": "a974",
	"./amenity/g0001.png": "4f1f",
	"./amenity/g0002.png": "3b8dd",
	"./amenity/g0003.png": "a98f",
	"./amenity/g0004.png": "a317",
	"./amenity/g0005.png": "e58e",
	"./amenity/g0006.png": "bdbe",
	"./amenity/g0007.png": "0700",
	"./amenity/g0008.png": "85c2",
	"./amenity/g0010.png": "0d6d",
	"./amenity/g0011.png": "ccf4",
	"./amenity/g0012.png": "b1a9",
	"./amenity/g0013.png": "94bd",
	"./amenity/g0014.png": "a0c2",
	"./amenity/g0015.png": "a693",
	"./amenity/g0016.png": "5737",
	"./amenity/g0017.png": "ae8b",
	"./amenity/g0018.png": "de8e",
	"./amenity/g0019.png": "1f83",
	"./amenity/g0020.png": "5085",
	"./amenity/g0021.png": "0208",
	"./amenity/g0022.png": "057a",
	"./amenity/g0023.png": "e90a",
	"./amenity/g0024.png": "2361",
	"./amenity/g0025.png": "9719",
	"./amenity/g0026.png": "9258",
	"./amenity/g0027.png": "817a",
	"./amenity/g0028.png": "640f",
	"./amenity/g0029.png": "8d54",
	"./amenity/g0030.png": "b230",
	"./amenity/g0031.png": "72e4",
	"./amenity/g0032.png": "3bd6",
	"./amenity/g0033.png": "c9cf",
	"./amenity/g0034.png": "b3fa",
	"./amenity/g0035.png": "52b5",
	"./amenity/g0036.png": "305d",
	"./amenity/g0037.png": "9785",
	"./amenity/g0038.png": "1f74",
	"./amenity/g0039.png": "8d27",
	"./amenity/g0040.png": "902e",
	"./amenity/g0041.png": "dda7",
	"./amenity/g0042.png": "4a94",
	"./amenity/g0043.png": "1687",
	"./amenity/g0044.png": "baf2",
	"./amenity/g0045.png": "ee95",
	"./amenity/g0046.png": "5185",
	"./amenity/g0047.png": "68af",
	"./amenity/g0048.png": "6581",
	"./amenity/g0049.png": "d0db",
	"./amenity/g0050.png": "f807",
	"./amenity/g0051.png": "4ad0",
	"./amenity/g0052.png": "a11c",
	"./amenity/g0053.png": "e6fd",
	"./amenity/g0054.png": "5b2c",
	"./amenity/g0055.png": "a03d",
	"./amenity/g0056.png": "4616",
	"./amenity/g0057.png": "4e65",
	"./amenity/g0058.png": "372d",
	"./amenity/g0059.png": "3167",
	"./amenity/g0060.png": "0003",
	"./amenity/g0061.png": "af98",
	"./amenity/g0062.png": "ef94",
	"./amenity/g0063.png": "0ecd",
	"./amenity/g0064.png": "85d3",
	"./amenity/g0065.png": "8520",
	"./amenity/g0066.png": "725b",
	"./amenity/g0067.png": "c729",
	"./amenity/g0068.png": "4259",
	"./amenity/g0100.png": "4ed6",
	"./amenity/g0101.png": "1cd8",
	"./amenity/g0102.png": "e787",
	"./amenity/g0103.png": "46b1",
	"./amenity/g0104.png": "c7c3",
	"./amenity/g0105.png": "07fb",
	"./amenity/g0106.png": "1a04",
	"./amenity/g0107.png": "df43",
	"./amenity/g0108.png": "95f0",
	"./amenity/g0109.png": "977c",
	"./amenity/g0111.png": "ca6b",
	"./amenity/g0112.png": "2210",
	"./amenity/g0113.png": "c16f",
	"./amenity/g0114.png": "c834",
	"./amenity/g0115.png": "d321",
	"./amenity/g0116.png": "f788",
	"./amenity/g0117.png": "40f9",
	"./amenity/g0118.png": "f781",
	"./amenity/g0119.png": "a2c3",
	"./amenity/g0120.png": "3648",
	"./amenity/g0121.png": "2905",
	"./amenity/g0122.png": "b0a3",
	"./amenity/g0123.png": "24db",
	"./amenity/g0124.png": "f0cd",
	"./amenity/g0125.png": "ec1e",
	"./amenity/g0126.png": "f696",
	"./amenity/g0127.png": "34c8",
	"./amenity/g0128.png": "b2e0",
	"./amenity/g0129.png": "9d3b",
	"./amenity/g0130.png": "619f",
	"./amenity/g0131.png": "6c4a",
	"./amenity/g0132.png": "1045",
	"./amenity/g0133.png": "3fdb",
	"./amenity/g0134.png": "30c3",
	"./amenity/g0136.png": "a160",
	"./amenity/g0137.png": "2881",
	"./amenity/g0138.png": "6319",
	"./amenity/g0139.png": "1262",
	"./amenity/g0140.png": "a4816",
	"./amenity/g0141.png": "37e4",
	"./amenity/g0142.png": "9a6d",
	"./amenity/g0143.png": "a505",
	"./amenity/g0144.png": "1912",
	"./amenity/g0145.png": "744f",
	"./amenity/g0146.png": "52c6",
	"./amenity/g0147.png": "af9b",
	"./amenity/g0148.png": "da6e",
	"./amenity/g0149.png": "184a",
	"./amenity/g0150.png": "925d",
	"./amenity/g0151.png": "f140",
	"./amenity/g0152.png": "c790",
	"./amenity/g0153.png": "e7b2",
	"./amenity/g0154.png": "0c5e",
	"./amenity/g0155.png": "005c",
	"./amenity/g0156.png": "5d90",
	"./amenity/g0157.png": "6754",
	"./amenity/g0158.png": "22b4",
	"./amenity/g0159.png": "52c0",
	"./amenity/g0160.png": "2164",
	"./amenity/g0161.png": "4f92",
	"./amenity/g0162.png": "b008",
	"./amenity/g0163.png": "cc21",
	"./amenity/g0164.png": "551d",
	"./amenity/g0165.png": "ca5b",
	"./amenity/g0166.png": "f18e",
	"./amenity/g0167.png": "e550",
	"./amenity/g0168.png": "a719",
	"./amenity/g0169.png": "3d8c",
	"./amenity/g0170.png": "88f2",
	"./amenity/g0171.png": "1ee8",
	"./amenity/g0172.png": "8c84",
	"./amenity/g0173.png": "3ed7",
	"./amenity/g0174.png": "0393",
	"./amenity/g0175.png": "4e36",
	"./amenity/g0176.png": "a8c3",
	"./amenity/g0200.png": "07fe",
	"./amenity/g0201.png": "1748",
	"./amenity/g0202.png": "191e",
	"./amenity/g0203.png": "59e9",
	"./amenity/g0204.png": "408a",
	"./amenity/g0205.png": "7f76",
	"./amenity/g0206.png": "50b1",
	"./amenity/g0207.png": "441a",
	"./amenity/g0208.png": "d18e",
	"./amenity/g0209.png": "c8d2",
	"./amenity/g0210.png": "0edc",
	"./amenity/g0211.png": "c831",
	"./amenity/g0212.png": "d070",
	"./amenity/g0213.png": "e49b",
	"./amenity/g0214.png": "b41d",
	"./amenity/g0215.png": "bed7",
	"./amenity/g0216.png": "6b6b",
	"./amenity/g0217.png": "c11d",
	"./amenity/g0218.png": "6283",
	"./amenity/g0219.png": "485e",
	"./amenity/g0220.png": "40f8",
	"./amenity/g0221.png": "97fc",
	"./amenity/g0222.png": "30af",
	"./amenity/g0223.png": "9050",
	"./amenity/g0224.png": "7d4c",
	"./amenity/g0225.png": "d0f7",
	"./amenity/g0226.png": "54d8",
	"./amenity/g0227.png": "1d4e",
	"./amenity/g0228.png": "5abc",
	"./amenity/g0229.png": "6b3a",
	"./amenity/g0230.png": "659d",
	"./amenity/g0231.png": "c000",
	"./amenity/g0232.png": "93ee",
	"./amenity/g0233.png": "88d5",
	"./amenity/g0234.png": "6f01",
	"./amenity/g0235.png": "967f",
	"./amenity/g0236.png": "2264",
	"./amenity/g0237.png": "b2d8",
	"./amenity/g0238.png": "3d1e",
	"./amenity/g0239.png": "3133",
	"./amenity/g0240.png": "afdd",
	"./amenity/g0241.png": "373e",
	"./amenity/g0242.png": "6383",
	"./amenity/g0243.png": "6271",
	"./amenity/g0244.png": "7034",
	"./amenity/g0245.png": "ff30",
	"./amenity/g0246.png": "1288",
	"./amenity/g0247.png": "e44f",
	"./amenity/g0248.png": "7167",
	"./amenity/g0249.png": "32d8",
	"./amenity/g0250.png": "7104",
	"./amenity/g0251.png": "8fbb",
	"./amenity/g0252.png": "63831",
	"./amenity/g0253.png": "7d35",
	"./amenity/g0254.png": "95be",
	"./amenity/g0255.png": "3276",
	"./amenity/g0256.png": "d8ff",
	"./amenity/g0257.png": "8886",
	"./amenity/g0258.png": "0471",
	"./amenity/g0259.png": "0144",
	"./amenity/g0260.png": "b303",
	"./amenity/g0261.png": "0583",
	"./amenity/g0262.png": "257b",
	"./amenity/g0263.png": "6c1b",
	"./amenity/g0264.png": "42fa",
	"./amenity/g0265.png": "b3ab",
	"./amenity/g0266.png": "2b72",
	"./amenity/g0267.png": "42ba",
	"./amenity/g0268.png": "2314",
	"./amenity/t0001.png": "1cac",
	"./banner_back.png": "56c9",
	"./banner_localinfo.png": "faa3",
	"./bg_instagram_feed.png": "bedd",
	"./bookmark.png": "e3d3",
	"./btn_destination_input.png": "a676",
	"./btn_destination_map.png": "d993",
	"./btn_destination_preset.png": "2de2",
	"./btn_international_pay.png": "287c",
	"./btn_normal_pay.png": "4585",
	"./btn_pg_alipay.png": "345a",
	"./btn_pg_paypal.png": "c607",
	"./btn_pg_wechatpay.png": "acc1",
	"./check_wh.png": "1810",
	"./chevron-right.png": "f18f",
	"./complete.png": "0b3e",
	"./ellipsis.png": "76c4",
	"./flag.png": "5904",
	"./iSTAY.png": "f354",
	"./ico_amenity.png": "cdf6",
	"./ico_arr_down_wh.png": "3b30",
	"./ico_attach_img.png": "d1ec",
	"./ico_back.png": "25a3",
	"./ico_back_white.png": "b4a6",
	"./ico_calendar_black.png": "9245",
	"./ico_cart.png": "1f47",
	"./ico_cart_order.png": "5399",
	"./ico_cart_white.png": "81bb",
	"./ico_clear.png": "c8e0",
	"./ico_clock.png": "113f",
	"./ico_clock_wh.png": "d84c",
	"./ico_coupon.png": "a2aa",
	"./ico_credit-card.png": "9f08",
	"./ico_destination_pin.png": "d20a",
	"./ico_disabled_on.png": "6306",
	"./ico_door.png": "fa6f",
	"./ico_fan.png": "e234",
	"./ico_finger.png": "f718",
	"./ico_google_translate.png": "f688",
	"./ico_grid.png": "e8df",
	"./ico_home_wh.png": "62bc",
	"./ico_hotel.png": "b957",
	"./ico_invoice.png": "4d56",
	"./ico_is_destination.png": "bb50",
	"./ico_is_destination_bk.png": "4aa0",
	"./ico_list.png": "8573",
	"./ico_localinfo.png": "4ae7",
	"./ico_localinfo_star.png": "842f",
	"./ico_location.png": "4e26",
	"./ico_location_pin.png": "e227",
	"./ico_lock.png": "9d16",
	"./ico_logout.png": "0a06",
	"./ico_member.png": "41d1",
	"./ico_mobile.png": "ec99",
	"./ico_mypage_cart.png": "95d9",
	"./ico_mypage_coupon.png": "eae0",
	"./ico_mypage_mobility.png": "51f7",
	"./ico_mypage_order.png": "292c",
	"./ico_mypage_payment.png": "9098",
	"./ico_mypage_reservation.png": "bb1f",
	"./ico_no_destination.png": "406b",
	"./ico_no_destination_bk.png": "c4ce",
	"./ico_order.png": "5f65",
	"./ico_paid.png": "6370",
	"./ico_payment.png": "a949",
	"./ico_payment_default.png": "af19",
	"./ico_payment_disabled.png": "47dc",
	"./ico_plane.png": "4002",
	"./ico_power.png": "72af",
	"./ico_preview_m.png": "bac3",
	"./ico_preview_t.png": "1cdb",
	"./ico_preview_w.png": "1e21",
	"./ico_question.png": "a3d1",
	"./ico_rateStar.png": "b936",
	"./ico_reload_wh.png": "5d2e",
	"./ico_reservation.png": "1a62",
	"./ico_resize.png": "8d478",
	"./ico_roomcharge.png": "e0cd",
	"./ico_roomcharge_default.png": "48fd",
	"./ico_roomcharge_disabled.png": "aed0",
	"./ico_send.png": "849f",
	"./ico_send_video.png": "c8bf",
	"./ico_speaker.png": "0865",
	"./ico_start_pin.png": "471a",
	"./ico_tablet.png": "d07d",
	"./ico_talk_bot.png": "b9eb",
	"./ico_talk_info.png": "e5d5",
	"./ico_talk_user.png": "9903",
	"./ico_talk_user_1.png": "2326",
	"./ico_talk_user_2.png": "acf0",
	"./ico_tel.png": "aab8",
	"./ico_touchmove_horizontal.png": "0bb9",
	"./ico_tv.png": "39fc",
	"./ico_unRateStar.png": "2347",
	"./ico_undo.png": "3162",
	"./ico_unlock.png": "148c",
	"./ico_unlock_wh.png": "51b5",
	"./ico_video_play.png": "e781",
	"./ico_window.png": "7df3",
	"./ico_zoomin.png": "9af6",
	"./ico_zoomout.png": "7b8b",
	"./img_product_default.png": "6b26",
	"./img_qr_fail.png": "ff09",
	"./img_qr_loading.png": "5161",
	"./istay-orange-text.png": "117e",
	"./istay-orange.png": "1fb0",
	"./istay-white-text.png": "99b1",
	"./istay-white.png": "eff5",
	"./key-round.png": "a364",
	"./languages.png": "4b90",
	"./localType/bar.png": "c969",
	"./localType/cafe.png": "c745",
	"./localType/localInfo.png": "ac7e",
	"./localType/park.png": "37a4",
	"./localType/restaurant.png": "ba00",
	"./localType/roundArrow.png": "f1ec",
	"./localType/tourist_attraction.png": "0b51",
	"./localinfo.png": "f842",
	"./localinfo_nodata.png": "b43e",
	"./lock.png": "c2b0",
	"./logo_google_translate.png": "6d49",
	"./minus_wh.png": "a19b",
	"./mobile_check.png": "e8c8",
	"./mobile_warn.png": "d665",
	"./passed.png": "b146",
	"./plus_wh.png": "6ae1",
	"./product_stkr_best.png": "d0b5",
	"./product_stkr_event.png": "c149",
	"./product_stkr_heritage.png": "6a84",
	"./product_stkr_promotion.png": "2968",
	"./product_stkr_sale.png": "9b9e",
	"./product_stkr_signature.png": "2add",
	"./question.png": "7d26",
	"./refresh-ccw.png": "08b9",
	"./refresh-cw.png": "3973",
	"./required.png": "b213",
	"./right_arrow.png": "6fbb",
	"./roomcontroller/ico_curtain_1.png": "1161",
	"./roomcontroller/ico_curtain_2.png": "26b4",
	"./roomcontroller/ico_curtain_3.png": "7c2a",
	"./roomcontroller/ico_curtain_4.png": "0a17",
	"./roomcontroller/ico_default.png": "6b88",
	"./roomcontroller/ico_dm_1.png": "34b2",
	"./roomcontroller/ico_dm_2.png": "fca2",
	"./roomcontroller/ico_door_1.png": "be15",
	"./roomcontroller/ico_door_2.png": "8b7c",
	"./roomcontroller/ico_fcu_1.png": "47d1",
	"./roomcontroller/ico_fcu_2.png": "660e",
	"./roomcontroller/ico_fcu_3.png": "63db",
	"./roomcontroller/ico_fcu_4.png": "5292",
	"./roomcontroller/ico_fcu_5.png": "ba5c",
	"./roomcontroller/ico_light_1.png": "da87",
	"./roomcontroller/ico_light_2.png": "cb8e",
	"./roomcontroller/ico_light_3.png": "7977",
	"./roomcontroller/ico_light_4.png": "c064",
	"./roomcontroller/ico_light_5.png": "f164",
	"./skin_active_menu_type1.png": "b4a2",
	"./skin_active_menu_type_block.png": "f37d",
	"./skin_active_menu_type_default.png": "1c43",
	"./sns_facebook.png": "12c5",
	"./sns_flickr.png": "ddd1",
	"./sns_instagram.png": "460b",
	"./sns_tripadvisor.png": "0828",
	"./sns_twitter.png": "17e8",
	"./sns_youtube.png": "3cf7",
	"./ticket.png": "493e",
	"./tvcontrol.png": "3486",
	"./tvcontrol_nodata.png": "5fe8",
	"./tvcontroller/ico_brightness+.png": "3707",
	"./tvcontroller/ico_brightness-.png": "c21e",
	"./tvcontroller/ico_fast_forward.png": "c1c2",
	"./tvcontroller/ico_netflix.png": "3f0f",
	"./tvcontroller/ico_next.png": "cf1f",
	"./tvcontroller/ico_pause.png": "8364",
	"./tvcontroller/ico_play.png": "4827",
	"./tvcontroller/ico_previous.png": "3a6d",
	"./tvcontroller/ico_rewind.png": "b5f8",
	"./tvcontroller/ico_stop.png": "57aa",
	"./warn.png": "c7ac",
	"./x.png": "5610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";